<div class="row justify-content-center g-1 mt-3">
	<div class="col-4"></div>
	<div class="col-2" style="display: flex;justify-content: end;">
		<img (click)="setLanguage(2)" src="https://tenant.mycapx.com/jp.svg" class="flagIcon" alt="Japanese Flag" title="{{string_data['LanguageJapanese'][language]}}"/>
	</div>
	<div class="col-2">
		<img (click)="setLanguage(1)" src="https://tenant.mycapx.com/us.svg" class="flagIcon" alt="US Flag" title="{{string_data['LanguageEnglish'][language]}}"/>
	</div>
	<div class="col-4"></div>
</div>

<div class="row justify-content-center mt-2">
	<div class="col-md-6 col-lg-4">
		<div class="card shadow-sm">
			<div class="card-body">
				<h2 class="card-title text-center mb-4">{{ string_data.LogIn[language] }}</h2>
				<div>
					<div class="mb-3">
						<label for="email" class="form-label">{{ string_data.Email[language] }}</label>
						<input type="email" id="email" class="form-control" [(ngModel)]="email" name="email" required autocomplete="username" (change)="resetError()"/>
					</div>
					<div class="mb-3">
						<label for="password" class="form-label">{{ string_data.Password[language] }}</label>
						<input type="password" id="password" class="form-control" [(ngModel)]="password" name="password" required autocomplete="current-password" (change)="resetError()" (keyup.enter)="onLogin()"/>
					</div>
					<button (click)="onLogin()" class="btn btn-primary w-100" autofocus>
						{{ string_data.Submit[language] }}
					</button>
				</div>
				<div *ngIf="errorMessage" class="alert alert-danger mt-3" role="alert">
					{{ errorMessage }}
				</div>
			</div>
		</div>
	</div>
</div>